/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCreateCycleSubjectDto } from '../../models/amoxcalli-create-cycle-subject-dto';
import { AmoxcalliCycleSubjectDtoApiResponse } from '../../models/amoxcalli-cycle-subject-dto-api-response';

export interface ApiCycleSubjectsPost$Plain$Params {
      body?: AmoxcalliCreateCycleSubjectDto
}

export function apiCycleSubjectsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiCycleSubjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliCycleSubjectDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiCycleSubjectsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliCycleSubjectDtoApiResponse>;
    })
  );
}

apiCycleSubjectsPost$Plain.PATH = '/api/cycle-subjects';
